<script>
export default {
  data() {
    return {
      localLoading: false
    };
  },
  props: {
    loading: Boolean
  },
  mounted() {
    this.localLoading = this.loading;
    this.showHideLoading();
  },
  watch: {
    loading(v) {
      this.localLoading = v;
      this.showHideLoading();
    }
  },
  methods: {
    showHideLoading() {
      const value = this.localLoading ? 'block' : 'none';

      for (const v of document.getElementsByClassName("preloader-component")) {
        v.style.display = value;
      }

      for (const v of document.getElementsByClassName("status")) {
        v.style.display = value;
      }
    }
  }
};
</script>

<template>
  <div :class="{ 'is-loading': localLoading }">
    <div class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <slot/>
  </div>
</template>

<style scoped>
.is-loading {
  position: relative;
}

.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}

.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>